var map = {
	"./mappa-totem-0-small.jpg": "1a1a",
	"./mappa-totem-1-small.jpg": "09f2",
	"./mappa-totem-2-small.jpg": "bcab",
	"./mappa-totem-3-small.jpg": "9b8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e75";